// extracted by mini-css-extract-plugin
export default {"page":"page_page__S6g4f","main":"page_main__b95Ma","primary":"page_primary__mwp6m","secondary":"page_secondary__cfbrf","footer":"page_footer__kVMmr"};